import React from "react";
import SectorCRUDTable from "@/components/SectorCRUDTable";
import { Croissant } from "lucide-react";

export default function ChefProduction() {
  return (
    <SectorCRUDTable
      endpoint="/chef/secteur/production"
      eyebrow="Boulangerie / Fast-food · Production"
      title="Lots de production"
      sub="Tracez vos lots avec DLC pour les contrôles HACCP."
      testidPrefix="production"
      defaultRow={() => ({ produit: "", quantite: 0, unite: "pcs", date_production: new Date().toISOString().slice(0, 10), dlc: "", responsable: "", notes: "" })}
      columns={[
        { key: "produit", label: "Produit" },
        { key: "quantite", label: "Quantité", width: "100px", render: (v, row) => `${v} ${row.unite || ""}` },
        { key: "date_production", label: "Produit le", width: "120px", render: (v) => v ? new Date(v).toLocaleDateString("fr-FR") : "—" },
        { key: "dlc", label: "DLC", width: "120px", render: (v) => v ? <span className="font-bold text-[#E60000]">{new Date(v).toLocaleDateString("fr-FR")}</span> : "—" },
        { key: "responsable", label: "Responsable", width: "160px" },
      ]}
      fields={[
        { key: "produit", label: "Produit", span: 8, required: true, placeholder: "Baguette, croissant, pizza margherita…" },
        { key: "unite", label: "Unité", type: "select", span: 4, options: [
          { value: "pcs", label: "pcs" },
          { value: "kg", label: "kg" },
          { value: "l", label: "L" },
        ]},
        { key: "quantite", label: "Quantité", type: "number", step: "0.01", span: 6, required: true },
        { key: "responsable", label: "Responsable", span: 6, required: true },
        { key: "date_production", label: "Date production", type: "date", span: 6, required: true },
        { key: "dlc", label: "DLC (Date Limite Consommation)", type: "date", span: 6 },
        { key: "notes", label: "Notes", type: "textarea", span: 12 },
      ]}
      emptyIcon={Croissant}
      emptyText="Aucun lot enregistré."
    />
  );
}
